/**
 * The line above a form whose unsaved work came back after an expired
 * sign-in (src/lib/keptWork.ts). Discard drops the kept copy.
 */

import { type ReactNode } from 'react';
import { Button } from '@/components/primitives/Button';

export function KeptWorkNotice({ onDiscard }: { onDiscard: () => void }): ReactNode {
  return (
    <div
      role="status"
      data-testid="kept-work-notice"
      className="mb-3 flex flex-wrap items-center justify-between gap-2 rounded-card border border-sage-200 bg-sage-50 px-3 py-2 text-sm text-ink"
    >
      <span>Your unsaved work is back. Save it now.</span>
      <Button variant="ghost" size="sm" data-testid="kept-work-discard" onClick={onDiscard}>
        Discard
      </Button>
    </div>
  );
}
